import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-zpax-logo",
  templateUrl: "./zpax-logo.component.html",
  styleUrls: ["./zpax-logo.component.scss"],
  standalone: true,
  imports: [RouterLink],
})
export class ZpaxLogoComponent {}
